import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';
import { useCurrentUserStore } from '../store/RootStoreContext';
import { isAdmin, isAdminOrAgent } from '../utils/accountHelper';

type actionResource = 'user' | 'group';

type CanProps = {
    children: ReactNode;
} & (
    | { create: true; delete?: never; edit?: never; resource: actionResource; see?: never; suspend?: never }
    | { edit: true; create?: never; delete?: never; resource?: actionResource; see?: never; suspend?: never }
    | { delete: true; create?: never; edit?: never; resource?: actionResource; see?: never; suspend?: never }
    | { see: true; create?: never; delete?: never; edit?: never; resource?: never; suspend?: never }
    | { suspend: true; create?: never; delete?: never; edit?: never; resource?: never; see?: never }
);

const Can = ({ resource, ...rest }: CanProps): JSX.Element => {
    const { role } = useCurrentUserStore();

    if (rest?.edit || rest?.create) {
        if (resource === 'group') {
            if (isAdmin(role)) return <>{rest.children}</>;
        }
        if (resource === 'user') {
            if (isAdminOrAgent(role)) return <>{rest.children}</>;
        }

        if (isAdmin(role)) return <>{rest.children}</>;
    }

    if (rest?.delete) {
        if (isAdmin(role)) return <>{rest.children}</>;
    }

    if (rest?.see) {
        if (isAdmin(role)) return <>{rest.children}</>;
    }

    if (rest?.suspend) {
        if (isAdmin(role)) return <>{rest.children}</>;
    }

    return null;
};

export default observer(Can);
